import { render, staticRenderFns } from "./Schemes.vue?vue&type=template&id=f6358a74&scoped=true"
import script from "./Schemes.vue?vue&type=script&lang=js"
export * from "./Schemes.vue?vue&type=script&lang=js"
import style0 from "./Schemes.vue?vue&type=style&index=0&id=f6358a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6358a74",
  null
  
)

export default component.exports